import {type Node} from 'slate';
import {ReactEditor} from 'slate-react';

import {isEmptyArtifactVersionsGrid} from '../../PanelArtifactVersionMetrics/artifactVersionsGridUtils';
import {isArtifactVersionsGrid} from '../plugins/artifact-versions-grid';
import {isParagraph} from '../plugins/ParagraphTypes';
import {type TextWithFormatting, type WBSlateElementType} from './types';

type DOMNodeType = globalThis.Node;

const DOMNode = globalThis.Node;

function isDOMNode(value: any): value is DOMNodeType {
  return value instanceof DOMNode;
}

export function hasEditableTarget(
  editor: ReactEditor,
  target: EventTarget | null
): target is DOMNodeType {
  return (
    isDOMNode(target) &&
    ReactEditor.hasDOMNode(editor, target, {editable: true})
  );
}

export function isTextWithFormatting(node: Node): node is TextWithFormatting {
  return typeof (node as any).text === 'string';
}

export function isEmptySlateValue(value: WBSlateElementType[]): boolean {
  return value.every(isEmptySlateBlock);
}

function isEmptySlateBlock(element: WBSlateElementType): boolean {
  if (isParagraph(element)) {
    return element.children.every(isEmptyTextNode);
  }
  if (isArtifactVersionsGrid(element)) {
    return isEmptyArtifactVersionsGrid(element);
  }
  return false;
}

function isEmptyTextNode(node: Node): boolean {
  return (
    `text` in node && typeof node.text === `string` && node.text.trim() === ``
  );
}
